import useAuth from "../../Hooks/useAuth";

/** Stable submenu keys for active state / React keys */
const subId = (link) => (link || "").replace(/^\//, "").replace(/\//g, "-") || "sub";
const useSidebarData = (props) => {
  const { setAuth } = useAuth();
  return [
    {
      icon: (
        <i className="fi fi-rs-dashboard text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-dashboard text-base text-primaryblue"></i>
      ),
      linkName: "Dashboard",
      link: "/business-dashboard/dashboard",
    },
    {
      icon: (
        <i
          className="fi fi-rs-chart-user text-base cursor-pointer hover:text-primaryblue"
        
        ></i>
      ),
      linkName: "Public Profile",
      link: "/poster-profile",
      iconSelected: (
        <i className="fi fi-rs-chart-user text-base text-primaryblue"></i>
      ),
    },
    {
      icon: (
        <i className="fi fi-rs-rectangle-list text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-rectangle-list text-base text-primaryblue"></i>
      ),
      linkName: "Posts",
      subMenu: [
        {
          icon: (
            <i className="fi fi-rs-add-document text-base hover:text-primaryblue"></i>
          ),
          linkName: "Create Post",
          link: "/business-dashboard/posts/create-post",
          id: subId("/business-dashboard/posts/create-post"),
        },
        {
          icon: (
            <i className="fi fi-rs-shop text-base hover:text-primaryblue"></i>
          ),
          linkName: "Published",
          link: "/business-dashboard/posts/published",
          id: subId("/business-dashboard/posts/published"),
        },
        {
          icon: (
            <i className="fi fi-rs-code-pull-request-draft text-base hover:text-primaryblue"></i>
          ),
          linkName: "Drafts",
          link: "/business-dashboard/posts/drafts",
          id: subId("/business-dashboard/posts/drafts"),
        },
        {
          icon: (
            <i className="fi fi-rs-trash-clock text-base hover:text-primaryblue"></i>
          ),
          linkName: "Deleted",
          link: "/business-dashboard/posts/bin",
          id: subId("/business-dashboard/posts/bin"),
        },
        {
          icon: (
            <i className="fi fi-rs-flag text-base hover:text-primaryblue"></i>
          ),
          linkName: "Flagged",
          link: "/business-dashboard/posts/flagged",
          id: subId("/business-dashboard/posts/flagged"),
        },
      ],
    },
    {
      icon: (
        <i className="fi fi-rs-comment-alt-dots text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-comment-alt-dots text-base text-primaryblue"></i>
      ),
      linkName: "Messages",
      subMenu: [
        {
          icon: (
            <i className="fi fi-rs-inbox text-base hover:text-primaryblue"></i>
          ),
          linkName: "All messages",
          link: "/business-dashboard/inbox/chats",
          id: subId("/business-dashboard/inbox/chats"),
        },
        {
          icon: (
            <i className="fi fi-rs-ban text-base hover:text-primaryblue"></i>
          ),
          linkName: "Blocked",
          link: "/business-dashboard/inbox/blocked",
          id: subId("/business-dashboard/inbox/blocked"),
        },
        {
          icon: (
            <i className="fi fi-rs-trash text-base hover:text-primaryblue"></i>
          ),
          linkName: "Deleted",
          link: "/business-dashboard/inbox/deleted",
          id: subId("/business-dashboard/inbox/deleted"),
        },
      ],
    },
    {
      icon: (
        <i className="fi fi-rs-file-invoice text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-file-invoice text-base text-primaryblue"></i>
      ),
      linkName: "Quotes",
      subMenu: [
        {
          icon: (
            <i className="fi fi-rs-inbox text-base hover:text-primaryblue"></i>
          ),
          linkName: "All quotes",
          link: "/business-dashboard/inbox/quotes",
          id: subId("/business-dashboard/inbox/quotes"),
        },
        {
          icon: (
            <i className="fi fi-rs-trash text-base hover:text-primaryblue"></i>
          ),
          linkName: "Deleted",
          link: "/business-dashboard/inbox/deleted",
          id: "inbox-quotes-deleted",
        },
      ],
    },
    {
      icon: (
        <i className="fi fi-rs-star text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-star text-base text-primaryblue"></i>
      ),
      linkName: "Reviews",
      link: "/business-dashboard/inbox/reviews",
    },
    // {
    //   icon: (
    //     <i className="fi fi-rs-chart-histogram text-base hover:text-primaryblue"></i>
    //   ),
    //   iconSelected: (
    //     <i className="fi fi-rs-chart-histogram text-base text-primaryblue"></i>
    //   ),
    //   linkName: "Analytics",
    //   link: "#",
    // },
    {
      icon: (
        <i className="fi fi-rs-file-invoice-dollar text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-file-invoice-dollar text-base text-primaryblue"></i>
      ),
      linkName: "Subscription",
      link: "/business-dashboard/subscriptions/billing-details",
      // subMenu: [
      //   {
      //     icon: (
      //       <i className="fi fi-rs-tags text-base hover:text-primaryblue"></i>
      //     ),
      //     linkName: "Pricing",
      //     link: "/business-dashboard/subscriptions/pricing",
      //     id: generateRandomNumber(),
      //   },
      //   {
      //     icon: (
      //       <i className="fi fi-rs-file-invoice-dollar text-base hover:text-primaryblue"></i>
      //     ),
      //     linkName: "Billing",
      //     link: "/business-dashboard/subscriptions/billing-details",
      //     id: generateRandomNumber(),
      //   },
      // ],
    },
    {
      icon: (
        <i className="fi fi-rs-settings text-base hover:text-primaryblue"></i>
        
      ),
      iconSelected: (
        <i className="fi fi-rs-settings text-base text-primaryblue"></i>
        
      ),
      linkName: "Account",
      subMenu: [
        {
          icon: (
            <i className="fi fi-rs-user text-base hover:text-primaryblue"></i>
          ),
          linkName: "Profile",
          link: "/business-dashboard/settings/account",
          id: subId("/business-dashboard/settings/account"),
        },
        {
          icon: (
        
            <i className="fi fi-rs-briefcase text-base hover:text-primaryblue"></i>
          ),
          linkName: "Portfolio",
          link: "/business-dashboard/settings/manage-portfolio",
          id: subId("/business-dashboard/settings/manage-portfolio"),
        },
        {
          icon: (
            <i className="fi fi-rs-diploma text-base hover:text-primaryblue"></i>
          ),
          linkName: "Compliance",
          link: "/business-dashboard/settings/certifications",
          id: subId("/business-dashboard/settings/certifications"),
        },
        // {
        //   icon: (
        //     <i className="fi fi-rs-animated-icon text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Memberships",
        //   link: "/business-dashboard/settings/associations",
        //   id: generateRandomNumber(),
        // },
        // {
        //   icon: (
        //     <i className="fi fi-rs-rss text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Social Media",
        //   link: "/business-dashboard/settings/social-profiles",
        //   id: generateRandomNumber(),
        // },
        // {
        //   icon: (
        //     <i className="fi fi-rs-form text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Business contact",
        //   link: "/business-dashboard/settings/business-contact",
        //   id: generateRandomNumber(),
        // },
        // {
        //   icon: (
        //     <i className="fi fi-rs-calendar-clock text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Trading hours ",
        //   link: "/business-dashboard/settings/trading-hours",
        //   id: generateRandomNumber(),
        // },
        // {
        //   icon: (
        //     <i className="fi fi-rs-bank text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Payment method",
        //   link: "/business-dashboard/settings/payment-options",
        //   id: generateRandomNumber(),
        // },
        {
          icon: (
            <i className="fi fi-rs-key-skeleton-left-right text-base cursor-pointer hover:text-primaryblue"></i>
          ),
          linkName: "Security",
          link: "/business-dashboard/settings/security-verification",
          id: subId("/business-dashboard/settings/security-verification"),
        },
        {
          icon: (
            <i className="fi fi-rs-bell text-base cursor-pointer hover:text-primaryblue"></i>
          ),
          linkName: "Preferences",
          link: "/business-dashboard/settings/notification-preferences",
          id: subId("/business-dashboard/settings/notification-preferences"),
        },
        // {
        //   icon: (
        //     <i className="fi fi-rs-key-skeleton-left-right text-base cursor-pointer hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Reset password",
        //   link: "/business-dashboard/settings/reset-password",
        //   id: generateRandomNumber(),
        // },
      ],
    },
    // {
    //   icon: (
    //     <i className="fi fi-rs-comment-alt-dots text-base  hover:text-primaryblue"></i>
    //   ),
    //   iconSelected: (
    //     <i className="fi fi-rs-comment-alt-dots text-base text-primaryblue"></i>
    //   ),
    //   linkName: "Inbox",
    //   subMenu: [
    //     {
    //       icon: (
    //         <i className="fi fi-rs-comment-alt-dots text-base cursor-pointer hover:text-primaryblue"></i>
    //       ),
    //       linkName: "Messages",
    //       link: "/business-dashboard/inbox/chats",
    //       id: generateRandomNumber(),
    //     },
    //     {
    //       icon: (
    //         <i className="fi fi-rs-bell text-base cursor-pointer hover:text-primaryblue"></i>
    //       ),
    //       linkName: "Notifications",
    //       link: "/business-dashboard/inbox/notifications",
    //       id: generateRandomNumber(),
    //     },
    //     {
    //       icon: (
    //         <i className="fi fi-rs-star text-base cursor-pointer hover:text-primaryblue"></i>
    //       ),
    //       linkName: "Reviews",
    //       link: "/business-dashboard/inbox/reviews",
    //       id: generateRandomNumber(),
    //     },
    //   ],
    // },
    {
      icon: (
        <i className="fi fi-rs-ticket text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-ticket text-base text-primaryblue"></i>
      ),
      linkName: "Tickets",
      subMenu: [
        {
          icon: (
            <i className="fi fi-rs-add text-base hover:text-primaryblue"></i>
          ),
          linkName: "Create ticket",
          link: "/business-dashboard/tickets/create",
          id: subId("/business-dashboard/tickets/create"),
        },
        {
          icon: (
            <i className="fi fi-rs-rectangle-list text-base hover:text-primaryblue"></i>
          ),
          linkName: "Open",
          link: "/business-dashboard/tickets/open",
          id: subId("/business-dashboard/tickets/open"),
        },
        {
          icon: (
            <i className="fi fi-rs-rectangle-list text-base hover:text-primaryblue"></i>
          ),
          linkName: "Resolved",
          link: "/business-dashboard/tickets/resolved",
          id: subId("/business-dashboard/tickets/resolved"),
        },
        {
          icon: (
            <i className="fi fi-rs-rectangle-list text-base hover:text-primaryblue"></i>
          ),
          linkName: "Closed",
          link: "/business-dashboard/tickets/closed",
          id: subId("/business-dashboard/tickets/closed"),
        },
      ],
    },
    {
      icon: (
        <i className="fi fi-rs-exclamation text-base hover:text-primaryblue"></i>
      ),
      iconSelected: (
        <i className="fi fi-rs-exclamation text-base text-primaryblue"></i>
      ),
      linkName: "Help Center",
      subMenu: [
        // {
        //   icon: <i className="fi fi-rs-info text-base hover:primaryblue"></i>,
        //   linkName: "About",
        //   link: "/about-us",
        //   id: generateRandomNumber(),
        // },
        // {
        //   icon: (
        //     <i className="fi fi-rs-blog-pencil text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Blog",
        //   link: "/Blogs",
        //   id: generateRandomNumber(),
        // },
        {
          icon: (
            <i className="fi fi-rs-life-ring text-base hover:text-primaryblue"></i>
          ),
          linkName: "Help Centre",
          link: "/HelpCentre",
          id: subId("/HelpCentre"),
        },
        // {
        //   icon: (
        //     <i className="fi fi-rs-form text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Submit Ticket",
        //   link: "#",
        //   id: generateRandomNumber(),
        // },
        {
          icon: (
            <i className="fi fi-rs-time-fast text-base hover:text-primaryblue"></i>
          ),
          linkName: "Terms & Policy",
          link: "/terms-&-conditions",
          id: subId("/terms-&-conditions"),
        },
        // {
        //   icon: (
        //     <i className="fi fi-rs-incognito text-base hover:text-primaryblue"></i>
        //   ),
        //   linkName: "Privacy Policy",
        //   link: "/privacy-policy",
        //   id: generateRandomNumber(),
        // },
      ],
    },

    {
      icon: <i className="fi fi-rs-exit rotate-180 text-base hover:text-primaryblue"></i>,
      linkName: "Log out",
      isLogout: true,
      onClick: () => {
        localStorage.removeItem("LoginSession");
        if (props?.toggleDrawer) {
          props.toggleDrawer();
        }
        setAuth({
          user: null,
          roles: null,
          accessToken: "",
        });
      },
    },
  ];
};

export default useSidebarData;
